import { Json } from 'fp-ts/Json';
import * as C from 'io-ts/Codec';
import { LANGUAGE_LIST } from 'src/modules/common/constants/language';
import { Language } from 'src/types/common/Language';

export const LANGUAGE: C.Codec<unknown, Json, Language> = C.literal(
  ...LANGUAGE_LIST,
);
